import React from "react";
import BgPick from "../../images/pickDrop.png";
import BackButton from "../bars/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import TableModal from "../../components/TableModal";
import RedirectModal from "../../components/RedirectModal";
import { convert_24_to_12 } from "../../utils/util";
import NotActive from "../../components/alert/NotActive";
import { TableReservationRestaurantPageView } from "../../utils/Analytics";


function TableReserve() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const hotelId = urlArray[urlArray.length - 1];

  const [restaurantData, SetRestaurantData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [hotelData, SethotelData] = useState([]);
  const [closedRestaurantName, setClosedRestaurantName] = useState(null);

  const [restaurantHide, SetrestaurantHide] = useState(true);
  localStorage.setItem("hotel-id", hotelId);
  const [IsLoading, SetLoading] = useState(true);
  let [isOpen, setIsOpen] = useState(false);
  const [restaurantId, setRestaurantId] = useState();
  const [restaurantName, setRestaurantName] = useState("");
  const appUserId = localStorage.getItem("appUserId");
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const bookingParams = {
    appUserId: localStorage.getItem("appUserId"),
    reservationId: localStorage.getItem("reservationId"),
    guestId: localStorage.getItem("guestId"),
    hotelId: urlArray[urlArray.length - 1],
  };
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const [showRedirect, setShowRedirect] = useState(false);
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));

  useEffect(() => {
    window.scrollTo(0, 0);
    // if (localStorage.getItem("phone_no") == null) {
    //   navigate("../");
    // }
    const getResList = async () => {
      SetLoading(true);
      try {
        await axios({
          method: "get",
          url: `${baseURL}/api/restaurants/` + hotelId,

          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          if (response.data.data.length == 0) {
            setIsOpen(true);
          }
          SetRestaurantData(response.data.data);
          SethotelData(response.data.data);
        });
      } catch {}
    };
    getResList();
  }, []);

  const bookTable = (param, resName) => {
    // if (isCheckedIn == "true") {
    //   setRestaurantId(param);
    //   setRestaurantName(resName);
    // } else {
    //   setShowRedirect(true);
    // }
    setRestaurantId(param);
    setRestaurantName(resName);
  };

   useEffect(() => {
      TableReservationRestaurantPageView();
     }, []);

  console.log(restaurantData);

  return (
    <div>
      {/* {restaurantId && (
        <TableModal
          restaurantId={restaurantId}
          hide={() => setRestaurantId("")}
          bookingParams={bookingParams}
          reservationData={reservationData}
          resName={restaurantName}
        />
      )} */}
      {showRedirect && (
        <RedirectModal innerPage hideModal={() => setShowRedirect(false)} />
      )}
      <div className="mb-28">
        <div className="section-wrap pt-6">
          <div className="flex items-center space-x-3">
            <BackButton />
            <div className="guestName sm:text-center text-left">
              Table Reservation
            </div>
          </div>
          <div>
            <div className="gridTab grid grid-flow-row sm:grid-cols-2 grid-cols-1 gap-3 gap-x-4 mt-6">
              {restaurantHide
                ? restaurantData.map((restaurantData, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        if (restaurantData?.table_status == 1) {  
                          navigate("/tablereservation-form", {
                            state: restaurantData, 
                          });
                        } else {
                          console.log("The kitchen is closed!"); 
                          setClosedRestaurantName(restaurantData?.restaurant_name);
                          setShowAlert(true);
                        }
                      }}
                      type="button"
                      state={restaurantData}
                      className="flex flex-row sm:flex-col items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                    >
                      <div className="sm:w-full flex bg-gray-200 rounded-md overflow-hidden sm:h-[160px] w-[56px] h-[56px] ">
                        <img
                          width="100%"
                          height="100%"
                          className={`flex items-stretch bg-contain object-cover transition w-full sm:h-full ${
                            restaurantData?.table_status == 1 ? "" : "filter grayscale" }`}
                          src={restaurantData?.image}
                          alt="hotelGuide"
                        ></img>
                      </div>
                      <div className="flex-col pl-[10px] sm:pl-0 w-full">
                        <div className="sm:mt-2 mt-0 text-left sm:text-base text-[14px] font-medium">
                          {restaurantData?.restaurant_name}
                        </div>
                        {/* <div className="mt-1 sm:text-xs  text-left text-[11px] text-[#9A9A9A] font-medium">
                          {restaurantData?.cuisine} 
                        </div> */} 
                        {(restaurantData?.start_time && restaurantData?.close_time) ? <div className="mt-1 text-left text-[10px] text-[#9A9A9A] font-medium">
                           Working hours : {convert_24_to_12(restaurantData?.start_time ? restaurantData?.start_time:'')} - {convert_24_to_12(restaurantData?.close_time ? restaurantData?.close_time:'')}
                        </div> :""}
                        
                        {/* {restaurantData?.start_time  !=  restaurantData?.close_time ? <div className="mt-1 text-left text-[10px] text-[#9A9A9A] font-medium">
                           Working hours : {convert_24_to_12(restaurantData?.start_time ? restaurantData?.start_time:'')} - {convert_24_to_12(restaurantData?.close_time ? restaurantData?.close_time:'')}
                        </div> : <div className="mt-1  text-left text-[11px] text-[#9A9A9A] font-medium"> Working hours : 24x7</div>} */}
                      </div>
                    </button>
                  ))
                : null}
               {showAlert &&  <NotActive Name={closedRestaurantName} title={'hotel'} hideModal={() => setShowAlert(false)}/> }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TableReserve;
